export const ORIGIN = {
  hq: 'hq',
  my: 'my',
  form: 'form',
  instaride: 'instaride',
  instarideForm: 'instaride:form',
  blueground: 'bg:form',
  heron: 'heron:form',
  vodafone: 'vodafone:form',
  viberpay: 'viberpay:form',
  instatrade: 'instatrade:form',
};

export const VEHICLE_TYPES = {
  car: 'car',
  bike: 'bike',
  van: 'van',
  scooter: 'scooter',
  patini: 'patini',
};

export const VEHICLE_ENGINE_TYPES = {
  ice: 0,
  mhev: 1,
  hev: 2,
  phev: 3,
  bev: 4,
};

export const PRODUCTS_ACTIONS = {
  feeDiscount: 2,
  signupFeeDiscount: 3,
  guaranteeDiscount: 4,
  orderTotalDiscount: 5,
  oneGuarantee: 6,
  freeMonths: 7,
};
